import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Barcode, BarcodeQuery, MemberCardQuery, MemberDetails, MemberQuery } from '@fgb/core';
import { BarcodeService } from '@fgb/core';
import { Observable } from 'rxjs';
import { MemberCard } from '@fgb/core';
import { config } from '@fgb/core';
import { BalanceQuery, BalanceService } from '@fgb/core';

@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit {
  @Input() memberId: string;
  @Input() isHomePage = false;
  @Input() showWallet: boolean = false;

  @ViewChild('barcodeContainer', { static: false }) barcodeContainerRef: ElementRef;
  barcode$: Observable<Barcode>;
  card$: Observable<MemberCard | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  virtualEcash$: Observable<number | undefined>;
  cashBack$: Observable<number | undefined>;
  pointsBalance$: Observable<number | undefined>;

  constructor(
    private barcodeService: BarcodeService,
    private barcodeQuery: BarcodeQuery,
    private balanceQuery: BalanceQuery,
    private balanceService: BalanceService,
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery
  ) {}

  ngOnInit() {
    this.barcodeService.fetchBarcode().toPromise();
    this.barcode$ = this.barcodeQuery.select();
    this.card$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.balanceService.fetchBalance(config.purseConfig.cashBack).subscribe();
    this.cashBack$ = this.balanceQuery.selectPurse(config.purseConfig.cashBack);
    this.balanceService.fetchBalance(config.purseConfig.virtualEcash).subscribe();
    this.virtualEcash$ = this.balanceQuery.selectPurse(config.purseConfig.virtualEcash);
  }
}
